module.exports = __webpack_public_path__ + "img/FRONT_220.62a34e33.png";